import {GET_SEARCH_TYPE} from '../../actiontypes'

export const SearchFetchReducer = (searchData) => {
    return (dispatch) => {
            dispatch({ type: GET_SEARCH_TYPE, payload: searchData});
    }      
};